import qs from 'qs';

angular.module('gym.bulkUpdates').directive('bulkUpdateUpdateRecords', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulk_updates/show/bulk_update_update_records.html.slim'),
    scope: {
      bulkUpdate: '=',
      visible: '=',
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "$http", "$state", "$window", "$timeout", "loadingAnimation", "flash", "TableService", "ActionCable", function($scope, $rootScope, $http, $state, $window, $timeout, loadingAnimation, flash, TableService, ActionCable) {
      var bulkUpdateUrl, displayConfirmTabWithFilter, getStats, gym;
      gym = $rootScope.gym;
      bulkUpdateUrl = `/gyms/${gym.id}/bulk_update/bulk_updates/${$scope.bulkUpdate.id}`;
      $scope.pageParams = {};
      getStats = function() {
        var url;
        url = `${bulkUpdateUrl}/row_stats`;
        return $http.get(url).then(function(response) {
          return $scope.stats = response.data;
        });
      };
      $scope.$watch('visible', function(visible) {
        if (visible) {
          return getStats();
        }
      });
      $scope.isValidating = function() {
        return $scope.bulkUpdate.status === 'row_validation_in_progress';
      };
      $scope.isUpdating = function() {
        var ref;
        return (ref = $scope.bulkUpdate.status) === 'queued_for_update' || ref === 'updating';
      };
      $scope.isUpdateFailed = function() {
        return $scope.bulkUpdate.status === 'update_failed';
      };
      $scope.isUpdateComplete = function() {
        return $scope.bulkUpdate.status === 'update_complete';
      };
      $scope.hasErrors = function() {
        var ref, ref1;
        if ($scope.isUpdateComplete()) {
          return false;
        }
        return ((ref = $scope.stats) != null ? ref.invalid_and_not_ignored_row_count : void 0) || ((ref1 = $scope.stats) != null ? ref1.rows_no_longer_candidates_count : void 0);
      };
      $scope.isReadyToStart = function() {
        return !$scope.hasErrors() && $scope.bulkUpdate.status === 'ready_for_review';
      };
      displayConfirmTabWithFilter = function(filter) {
        $scope.$emit('bulkImport:confirmChanges:setFilter', filter);
        return $timeout(function() {
          return $scope.setTab({
            tab: 'confirm',
            skipCheck: true
          });
        });
      };
      $scope.viewInvalidRows = function() {
        return displayConfirmTabWithFilter('invalid_only');
      };
      $scope.viewOutdatedRows = function() {
        return displayConfirmTabWithFilter('no_longer_candidates');
      };
      $scope.viewIgnoredRows = function() {
        return displayConfirmTabWithFilter('ignored_only');
      };
      $scope.viewRowsToUpdate = function() {
        return displayConfirmTabWithFilter('not_ignored');
      };
      $scope.markAsReviewed = function() {
        var params, url;
        url = `${bulkUpdateUrl}/mark_as_reviewed`;
        params = {
          bulk_record_update: {
            reason: $scope.pageParams.reason
          }
        };
        $scope.isLoading = true;
        return $http.put(url, params).then(function() {
          $scope.isLoading = false;
          return $scope.bulkUpdate.status = 'updating';
        }, function() {
          flash.error = "Request could not be completed. Please try again";
          return $scope.isLoading = false;
        });
      };
      $scope.createNewUpdate = function() {
        var params, url;
        $scope.isLoading = true;
        url = `/gyms/${gym.id}/bulk_update/bulk_updates`;
        params = {
          bulk_record_update: {
            update_type: 'membership'
          }
        };
        return $http.post(url, params).then(function(response) {
          var newUrl;
          newUrl = $state.href('gym.bulkUpdates.show', {
            id: response.data.id
          });
          $window.open(newUrl, '_self');
          return true;
        }, function(response) {
          var ref, ref1;
          $scope.isLoading = true;
          return flash.error = ((ref = response.data.errors) != null ? (ref1 = ref.status) != null ? ref1[0] : void 0 : void 0) || "Request could not be completed. Please try again";
        });
      };
      $scope.reload = function() {
        return $scope.recordsTable.reload();
      };
      $scope.queryParams = {
        filters: {
          update_status: ''
        }
      };
      $scope.$watch('visible', function(visible, previousVisible) {
        if (visible && !previousVisible && $scope.recordsTable) {
          return $scope.reload();
        }
      });
      $scope.$watch('bulkUpdate.status', function(status, previousStatus) {
        if ($scope.visible) {
          return $scope.reload();
        }
      });
      $scope.pageRange = function() {
        var fromCount, prevPagesCount;
        prevPagesCount = ($scope.records.page - 1) * $scope.records.count;
        fromCount = $scope.records.collection.length ? prevPagesCount + 1 : 0;
        return `${fromCount} - ${prevPagesCount + $scope.records.collection.length}`;
      };
      $scope.setPageSize = function(count) {
        return $scope.recordsTable.count(count);
      };
      return $scope.recordsTable = TableService.init({
        count: 20,
        getData: function(resolve, $params, beforeLoad) {
          var params, query, url;
          if (!$scope.visible || !$scope.isUpdateComplete()) {
            return;
          }
          $scope.recordsLoading = true;
          params = angular.extend({}, $params.url(), $scope.queryParams);
          beforeLoad(params);
          query = qs.stringify(params);
          url = `${bulkUpdateUrl}/records?${query}`;
          return $http.get(url).then(function(response) {
            $scope.records = response.data;
            $params.total(response.data.total);
            resolve(response.data.collection);
            return $scope.recordsLoading = false;
          }, function() {
            flash.error = "Request could not be completed. Please try again";
            return $scope.recordsLoading = false;
          });
        }
      });
    }]
  };
});
